import { isMobile } from '../../helpers/isMobile';
import { iconStates } from '../../core/pixi/icons';
import { SpinIconNumberProvider } from './spinIconNumberProvider';
import { gameMainDrawer } from '../../game/drawers/gameMainDrawer';
import { addToGameEvents, gameEvents } from '../../lib/gameEvents';
import { Timer, addToGameTimer, removeFromGameTimer } from '../../lib/timer';
import { Reel } from '../elementTypeService/Reel';
import { initWin } from '../elementTypeService/boardWin';
import { winBarStore } from '../../store/winBarStore';
import { bonusTypesEnum } from '../../constants/bonusTypes';
import { spinBarStore } from '../../store/spinBarStore';
import { userInfoStore } from '../../store/userInfoStore';
import { WinPopup } from '../elementTypeService/gameWin/gameWinPopups';
import { betBarStore } from '../../store/betBarStore';
import { gameStore } from '../../store/gameStore';
import { applicationStore } from '../../store/applicationStore';
import { MIN_BIG_WIN_POPUPS_ODD } from '../../helpers/getWinPopupType';
import { soundService, SoundTypes } from '../baseSoundService/soundService';
import { FAST_MODE_SPEED, FASTER_MODE_SPEED, STANDARD_MODE_SPEED } from '../../core/constants';
import { iframeService } from '../iframeService';
import { clearGameLoopManager, removeFromGameLoop } from '../../lib/gameLoop';
import { PopupTypes } from '../../constants/popupTypes';
import { addTouchControl } from './touchSpinControll';
import { gambleStore } from '../../store/gambleStore';
import { balanceUpdateHandler } from '../../helpers/balanceUpdateHandler';
import { handleCollect } from '../../helpers';
import { updateExpiresCount } from '../../helpers/jackpotHelpers';

let subs = [];
let reel;
let forced;
let columns;
let spinning;
let stopTimer;
let stopTimerEvent;
let spinEnded;
let colAnimation;
let stopSequentially;
let promiseSpinEnded;
let resolveSpinEnded;
let spinDirection = 1;
let stoppedColumnsCount;
let promiseSpinTimeEnded;
let openBigWinPopupTimeOut;
let resolveSpinTimeEnded;
let superColumnStarted = false;
let nextColumnStopTimerEvent = null;

const fastSpinDuration = 1500;
const standardSpinDuration = 1000;
const iconsOnStopAnimationPromises = [];
let spinDuration = spinBarStore.gameReelSpeedMode.standard
  ? standardSpinDuration
  : fastSpinDuration;

function reset() {
  promiseSpinEnded = new Promise((res) => {
    resolveSpinEnded = res;
  });

  promiseSpinTimeEnded = new Promise((res) => {
    resolveSpinTimeEnded = res;
  });
  stoppedColumnsCount = 0;
  forced = false;
  stopSequentially = false;
  nextColumnStopTimerEvent = null;
  iconsOnStopAnimationPromises.length = 0;
  superColumnStarted = false;
}

function stopColumnsAtOnce() {
  columns.forEach((column) => column.stopSpin(true));
  stopTimer.updateEventsTimes([300]);
}

function stopColumnsInFastMode() {
  if (spinBarStore.isDoubleClick) {
    stopColumnsAtOnce();
  } else {
    for (let i = 0; i < columns.length; i += 1) {
      setTimeout(() => {
        columns[i].stopSpin(spinBarStore.isDoubleClick);
      }, i * 100);
    }
  }
}

function stopColumnsSequentially() {
  if (spinBarStore.isDoubleClick) {
    stopColumnsAtOnce();
  } else {
    stopSequentially = true;
    columns[0].stopSpin(spinBarStore.isDoubleClick);
  }
}

function startStoppingTimer() {
  stopTimer?.destroy();
  // stopTimer = new Timer();
  resolveSpinTimeEnded.isTime = true;
  stopTimerEvent = stopTimer.add(spinDuration, resolveSpinTimeEnded);
}

// eslint-disable-next-line consistent-return
async function start() {
  spinBarStore.resetScattersCount();
  clearTimeout(openBigWinPopupTimeOut);
  if (spinning) {
    stopSequentially = true;
    forced = true;
    // stopColumnsAtOnce();
    return false;
  }
  // columns.forEach((col) => {
  //   col.fullUpdateFromResponseData();
  // });
  spinning = true;

  for (let i = 0; i < columns.length; i += 1) {
    columns[i]._finalDrawIcons.forEach((slotIcon) => {
      slotIcon.alpha = 1;
    });
  }
  reset();
  // updateIconsBeforeSpin();

  columns.forEach((column) => {
    column.startSpin(spinDirection);
  });
  // eslint-disable-next-line no-shadow
  // columns.forEach((reel) => {
  //   reel._finalDrawIcons.forEach((slotIcon) => {
  //     slotIcon.alpha = 1;
  //   });
  // });
  spinDirection = 1;
  clearGameLoopManager();

  startStoppingTimer();
  // stopTimer.updateEventsTimes([20]);

  await promiseSpinTimeEnded;
  // if (forced) stopColumnsAtOnce();
  // else stopColumnsSequentially();

  await promiseSpinEnded;
  await Promise.all(iconsOnStopAnimationPromises);
  spinning = false;
  if (winBarStore.expandingWildData?.every((el) => !el) && !winBarStore.winAmount) {
    spinBarStore.setIsSpinStart(false);
    gameMainDrawer.menuBar.toggleMenuIconOpacity();
  }
  spinBarStore.setIsDoubleClick(false);
  gameEvents.emit('spinStopped');
}

async function stopAllReels() {
  removeFromGameTimer(nextColumnStopTimerEvent);
  stopTimer?.destroy();
  gameMainDrawer.expandWildBar.isWildOpened = false;
  gameMainDrawer.lineWinBar.toggleLineWinBarContainerVisible(true);
  winBarStore.setWinBarSymbolsById(columns);
  soundService.stopAll();
  if (bonusTypesEnum.jackpot === gameStore.bonusType) {
    gameMainDrawer.spinBar.hideAutoBetPopup();
    gameMainDrawer.jackpotBar.startPopup();
    soundService.stop(SoundTypes.JackpotSymbolSound);
    soundService.play(SoundTypes.JackpotSceneTransition);
  }
  if (gameStore.bonusType === bonusTypesEnum.boostedJackpot) {
    gameMainDrawer.spinBar.hideAutoBetPopup();
    gameMainDrawer.boostedWheel.startBoostedWheelContainerGsapAnimation();
    updateExpiresCount(Date.now() + 295 * 1000, true);
  }
  if (spinBarStore.scatterDollarCount >= 3) {
    // eslint-disable-next-line no-shadow
    columns.forEach((reel) => {
      reel._finalDrawIcons.forEach((slotIcon) => {
        if (slotIcon.iconNumber === 10) {
          slotIcon.changeState(iconStates.win);
        } else {
          slotIcon.changeState(iconStates.noWin);
        }
      });
    });
  } else if (spinBarStore.scatterStarCount >= 3) {
    // eslint-disable-next-line no-shadow
    columns.forEach((reel) => {
      reel._finalDrawIcons.forEach((slotIcon) => {
        if (slotIcon.iconNumber === 11) {
          slotIcon.changeState(iconStates.win);
        } else {
          slotIcon.changeState(iconStates.noWin);
        }
      });
    });
  } else if (spinBarStore.jackpotIconCount >= 3) {
    // eslint-disable-next-line no-shadow
    columns.forEach((reel) => {
      reel._finalDrawIcons.forEach((slotIcon) => {
        if (slotIcon.iconNumber === 400) {
          slotIcon.icon.play('win', true);
        }
      });
    });
  }
  if (winBarStore.wins.length) {
    !gambleStore.gambleCount && balanceUpdateHandler();
    winBarStore.setIsLastWinAmountTextVisible(false);
    spinBarStore.setIsStopAllReels(true);
    if (winBarStore.expandingWildData?.some((el) => el)) {
      gameMainDrawer.expandWildBar.updateWildYAndPlayExpandAnimation();
    }
    gameEvents.emit('startWin');
    gameMainDrawer.lineWinBar.showAndHideWinCoinsAnimation(true);
    gameMainDrawer.betBar.updateLastWinAmount(`${winBarStore.winAmount}`);
    winBarStore.spinResultOdd < 35 && gameMainDrawer.spinBar.handleGambleStartButtonVisibleState();
  } else {
    winBarStore.setIsLastWinAmountTextVisible(true);
  }
  if (applicationStore.isMaintenance) {
    iframeService.reloadFrame();
  } else if (
    spinBarStore.selectedAutoBetCount &&
    gameStore.freeBetInfo?.reminingSpinCount !== 0 &&
    !winBarStore.winAmount
  ) {
    gameMainDrawer.spinBar.handleDoSpin();
  }
  if (!gameStore.freeBetInfo?.reminingSpinCount) {
    gameMainDrawer.betBar.updateQuickBetsState({ alpha: 1, isInteractive: true });
  }
  gameMainDrawer.betBar.updateLastWinText();
  gameMainDrawer.betBar.setLastWinContainerPosition();
  if (
    userInfoStore.balance < betBarStore.quickBetArr[0] &&
    spinBarStore.tournamentId &&
    !gameStore.tournamentInfo?.currentFreeBetCount
  ) {
    window.parent.postMessage({ name: PopupTypes.TournamentFinished }, '*');
    if (gambleStore.gambleCount) {
      gambleStore.setIsCollectBeforeSpin(false);
      handleCollect();
    }
    gameMainDrawer.freeBetBar.freeBetCountContainer.visible = false;
    gameMainDrawer.spinBar.hideGambleFeature();
  }
  if (gameStore.freeBetInfo?.reminingSpinCount === 0) {
    gameMainDrawer.spinBar.hideGambleFeature();
    gameMainDrawer.spinBar.hideAutoBetPopup();
    gameMainDrawer.freeBetBar.freeBetPopupContainer.visible = true;
    gameMainDrawer.freeBetBar.freeBetCountContainer.visible = false;
    gameMainDrawer.spinBar.initAutoBetButton();
    spinBarStore.setSelectedAutoBetCount(null);
    spinBarStore.setNextFreeBet(null);
    spinBarStore.setIsAutoBetStart(false);
    spinBarStore.setFreeBetId(null);
    gameMainDrawer.betBar.decreaseWinAndLastWinContainerPositionByFreeBet();
    betBarStore.setFreeBetSelectedAmount(null);
    gameMainDrawer.freeBetBar.updateFreeBetPopupTexts(
      gameStore.canvasTranslationKeys.BONUS_ROUND_POPUP,
      gameStore.canvasTranslationKeys.TOTAL_WIN,
      gameStore.canvasTranslationKeys.OK,
      gameStore.freeBetInfo.totalWin,
      true
    );
    gameMainDrawer.freeBetBar.updateFreeBetSelectedAmount(true);
    // }
  }
  if (winBarStore.expandingWildData?.every((el) => !el) && !winBarStore.winAmount) {
    spinBarStore.setIsSpinStart(false);
  }
  // spinBarStore.setIsDoubleClick(false);
  // MIN_BIG_WIN_POPUPS_ODD
  if (winBarStore.spinResultOdd >= MIN_BIG_WIN_POPUPS_ODD) {
    // addToGameTimer(1000, () => {
    //   bigWinStartPromise();
    // });
    // await bigWinStart;
    openBigWinPopupTimeOut = setTimeout(() => {
      if (!gambleStore.isGamble) {
        gameEvents.emit('openWinPopup');
        gameStore.setIsOpenBigWinPopup(true);
      }
    }, 1000);
  }
}

function activeColumnParams(reelColumn) {
  if (!isMobile()) {
    if (reelColumn.index === 1) {
      colAnimation.x = 726.5;
    } else if (reelColumn.index === 2) {
      colAnimation.x = 907.5;
    } else {
      colAnimation.x = 1088;
    }
  } else if (reelColumn.index === 1) {
    colAnimation.x = 272.5;
  } else if (reelColumn.index === 2) {
    colAnimation.x = 376;
  } else {
    colAnimation.x = 482;
  }
}

// eslint-disable-next-line no-shadow
async function onColumnStop(reel) {
  if (reel.index === 4) {
    // winBarStore.setWinBarSymbolsById(columns);
    // if (winBarStore.winAmount) {
    //   await gameMainDrawer.expandWildBar.updateWildYAndPlayExpandAnimation();
    // }
  }
  reel._finalDrawIcons.forEach((icon) => {
    if (+icon.iconNumber === 9) {
      icon.icon.play('drop');
      icon.icon.addListener(
        'complete',
        () => {
          icon.icon.play(iconStates.idle, true);
        },
        null,
        'drop'
      );
    }
  });
  stoppedColumnsCount += 1;
  const isLastColumn = stoppedColumnsCount === columns.length;
  // eslint-disable-next-line no-empty
  if (isLastColumn) {
    stopTimer.updateEventsTimes([200]);
  } else if (spinBarStore.isDoubleClick || spinBarStore.gameReelSpeedMode.faster) {
    gameEvents.emit('stopColumnsAtOnce');
  } else {
    const nextColumn = columns[stoppedColumnsCount];
    if (spinBarStore.jackpotIconCount >= 2) {
      activeColumnParams(reel);
      superColumnStarted = true;
      soundService.play(SoundTypes.JackpotSymbolSound);
      colAnimation.visible = true;
      colAnimation.play('jackpot', true);
      if (spinBarStore.jackpotIconCount === 3) {
        colAnimation.visible = false;
        gameMainDrawer.spinBar.hideAutoBetPopup();
        spinBarStore.setIsSpinStart(true);
        nextColumn.stopSpin();
      }
      removeFromGameTimer(nextColumnStopTimerEvent);
      nextColumnStopTimerEvent = null;
      removeFromGameTimer(nextColumnStopTimerEvent);
      nextColumnStopTimerEvent = addToGameTimer(1500, () => {
        soundService.stop(SoundTypes.JackpotSymbolSound);
        nextColumn.stopSpin(spinBarStore.isDoubleClick);
      });
    } else {
      nextColumn.stopSpin(spinBarStore.isDoubleClick);
    }
  }
  if (reel.index === columns.length - 1 && superColumnStarted) {
    colAnimation.stop();
    colAnimation.visible = false;
  }
  if (
    isLastColumn &&
    ((spinBarStore.isAutoBetStart && spinBarStore.selectedAutoBetCount) || winBarStore.winAmount)
  ) {
    removeFromGameTimer(spinEnded);
    removeFromGameLoop(resolveSpinEnded);
    spinEnded = addToGameTimer(100, resolveSpinEnded);
  } else if (isLastColumn) {
    resolveSpinEnded();
  }
}

function stop() {
  if (!spinning || forced) return;
  forced = true;
  if (stopSequentially) {
    stopSequentially = false;
    if (nextColumnStopTimerEvent) {
      removeFromGameTimer(nextColumnStopTimerEvent);
      // gameEvents.emit('stopSuperColumn');
    }
    stopColumnsAtOnce();
  } else {
    stopTimer.accelerate([0]);
  }
}

function updateReelSpeed() {
  const { standard, fast } = spinBarStore.gameReelSpeedMode;
  let columnsMoveSpeed = standard
    ? STANDARD_MODE_SPEED.web
    : fast
    ? FAST_MODE_SPEED.web
    : FASTER_MODE_SPEED.web;

  if (isMobile()) {
    columnsMoveSpeed = standard
      ? STANDARD_MODE_SPEED.mobile
      : fast
      ? FAST_MODE_SPEED.mobile
      : FASTER_MODE_SPEED.mobile;
  }
  columns.forEach((el) => {
    el.columnsMoveSpeed = columnsMoveSpeed;
  });
  gameStore.setReelSpeed(columnsMoveSpeed);
  spinDuration = standard ? standardSpinDuration : fastSpinDuration;
}

function setSwipeDirection(arg) {
  spinDirection = arg;
}

function startSpin() {
  gameMainDrawer.spinBar.handleDoSpin();
}

const events = {
  spinStarted: start,
  stopSpin: stop,
  stopColumnsSequentially: stopColumnsSequentially,
  stopColumnsAtOnce: stopColumnsAtOnce,
  stopColumnsInFastMode: stopColumnsInFastMode,
  spinStopped: stopAllReels,
  updateReelSpeed,
  startSpin,
  setSwipeDirection,
};

function calculateReelParams() {
  const rows = 3;
  const iconsDistance = 0;
  const iconsInReel = 3;
  const reverseLineOffset = isMobile() ? 15 : 35;
  const iconsHeight = isMobile() ? 100 : 170;
  const finalPositions = isMobile() ? [0, 100, 200] : [0, 170, 340];
  const topLine = Math.floor(finalPositions[0] - iconsHeight / 2);
  const webColumnPositions = [276, 456, 636, 816, 996];
  const mobileColumnPositions = [0, 105, 210, 315, 420];
  const bottomLine = rows * iconsHeight + (rows - 1) * iconsDistance;
  const { standard, fast } = spinBarStore.gameReelSpeedMode;
  let columnsMoveSpeed = standard
    ? STANDARD_MODE_SPEED.web
    : fast
    ? FAST_MODE_SPEED.web
    : FASTER_MODE_SPEED.web;

  if (isMobile()) {
    columnsMoveSpeed = standard
      ? STANDARD_MODE_SPEED.mobile
      : fast
      ? FAST_MODE_SPEED.mobile
      : FASTER_MODE_SPEED.mobile;
  }
  gameStore.setReelSpeed(columnsMoveSpeed);
  return {
    iconsInReel,
    iconsHeight,
    iconsDistance,
    topLine,
    webColumnPositions,
    mobileColumnPositions,
    bottomLine,
    takeOffLineOffset: 50,
    reverseLineOffset,
    columnsMoveSpeed,
    iconMargins: { default: (iconsHeight + iconsDistance) / 2 },
    finalPositions,
  };
}

export const setColumns = () => {
  columns = winBarStore.winBarSymbolsById;
};

export function initReels(spinContainer, winContainer) {
  columns = [];
  const columnsCount = 5;
  const reelParams = calculateReelParams();
  for (let columnNumber = columnsCount - 1; columnNumber >= 0; columnNumber -= 1) {
    reel = new Reel(
      columnNumber,
      spinContainer,
      winContainer,
      reelParams,
      new SpinIconNumberProvider(columnNumber),
      columnNumber === columnsCount - 1
    );
    reel.on('stopped', onColumnStop);
    columns[columnNumber] = reel;
  }
}

export function getActualIcon(column, row) {
  return columns[column].getRowIcon(row);
}

export function initStandardSpinManager(reelsContainer, winsContainer) {
  initReels(reelsContainer, winsContainer);
  stopTimer = new Timer();

  spinning = false;
  colAnimation = gameMainDrawer.jackpotBar.activeColumn;
  colAnimation.visible = false;
  addTouchControl(reelsContainer, columns);
  // refs.spinContainer.interactive = true;
  // refs.spinContainer.addOnDownHandler(stop);
  return {
    start() {
      reset();
      subs = addToGameEvents(events);
      spinning = false;
      // refs.spinContainer.show();
      columns.forEach((col) => {
        col.fullUpdateFromResponseData();
      });
      gameEvents.emit('standardSpinActivated');
      initWin();
      // eslint-disable-next-line new-cap
      const win = new WinPopup();
      // gameEvents.emit('startSpin');
    },
    stop() {
      subs.forEach((u) => u());
      columns.forEach((col) => {
        col.iconsToSpinContainer();
      });
      gameMainDrawer.slotBar.slotBarReelsContainer.visilbe = false;
    },
  };
}
